interface BankAccountImageProps {
  id: number;
}

function BankAccountImage({ id }: BankAccountImageProps) {
  let avatarSrc = "/blank.png";
  if (id)
    switch (id) {
      case 2:
        avatarSrc = "/parsian.svg";
        break;
      case 10:
        avatarSrc = "/snapp.svg";
        break;
    }
  return (
    <img
      src={avatarSrc}
      alt="Bank Account"
      className="img-thumbnail w-50" 
      style={{
        width: "50px",
        height: "50px",
      }}
    />
  );
}

export default BankAccountImage;
